module.exports = __webpack_public_path__ + "img/AccountBalanceOutlined.335e9128.svg";